import { useEffect, useState } from 'react';
import { setAppState } from '../services/appstate-service';
import { clearTags, subscribeData, subscribeFilters } from '../services/data-service';
import FiltersGroup from './filters-group';
import './filters-panel.scss';

const FiltersPanel = () => {

    const closePanel = () => {
        setAppState({filtersOpen: false});
    }

    const [data, setData] = useState([]);
    const [filters, setFilters] = useState([]);

    useEffect(() => {

        const onFilters = (newFilters) => {
            setFilters([...newFilters]);
        }

        const unsubscribeData = subscribeData(onData);
        const unsubscribeFilters = subscribeFilters(onFilters);

        return function cleanup() {
            unsubscribeData(onData);
            unsubscribeFilters(onFilters);
        }

    }, []);

    const onData = (newData) => {
        setData([...newData]);
    }

    const resetFilters = () => {
        clearTags();
        closePanel();
    }

    return(
        <div className="filters-panel">
            <div className="filters-panel-header">

                <div className="filters-prediction">
                    {data.length ?
                        data.length + (data.length > 1 ? ' ressources trouvées' : ' ressource trouvée') :
                        'Aucune ressource trouvée'
                    }
                </div>
                
                <button className="btn-close" onClick={closePanel}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                </button>
            </div>
            <div className="filters-container">
                {filters.map((group, index) => 
                    <FiltersGroup group={group} key={index} />
                )}
            </div>
            <div className="filters-panel-bottom">
                <div className="buttons-group">
                    <button className="btn-cancel" onClick={resetFilters}>Annuler</button>
                    <button className="btn-submit" onClick={closePanel}>Valider</button>
                </div>
            </div>
        </div>
    );
}

export default FiltersPanel;